import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideListComponent } from './side-list.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [CommonModule, FormsModule, FiAppTextSharedModule],
    declarations: [SideListComponent],
    exports: [SideListComponent],
})
export class SideListModule {}
